// Storefront editorial images (hero, banners, tiles) managed from the
// backoffice. A component asks for a slot by key; if no custom image has
// been uploaded the component falls back to its built-in bundled image.
import { useState, useEffect } from "react";
import { API_URL } from "./config";

let cache = null;
let inflight = null;

export function fetchSiteAssets() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(`${API_URL}/site-assets`)
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => {
        cache = {};
        for (const asset of list) {
          if (asset.imageUrl) cache[asset.key] = asset.imageUrl;
        }
        return cache;
      })
      .catch(() => {
        cache = {}; // API unreachable — every slot uses its built-in default
        return cache;
      });
  }
  return inflight;
}

// Serve Cloudinary uploads compressed and sized for banners
export function optimized(url, width = 1600) {
  if (
    typeof url !== "string" ||
    !url.includes("res.cloudinary.com") ||
    !url.includes("/upload/") ||
    url.includes("/upload/f_auto")
  ) {
    return url;
  }
  return url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);
}

export function useSiteAssets() {
  const [assets, setAssets] = useState(cache || {});
  useEffect(() => {
    fetchSiteAssets().then(setAssets);
  }, []);
  return assets;
}

// True once the slot list has been fetched (or failed) — lets components
// wait before painting a fallback, avoiding an old-image flash.
export function useSiteAssetsLoaded() {
  const [loaded, setLoaded] = useState(!!cache);
  useEffect(() => {
    fetchSiteAssets().then(() => setLoaded(true));
  }, []);
  return loaded;
}
